import { Container, i18n, Icon, utils } from "@common";
import { routerPaths } from '../../oauth/tool';
import { transferToRetrieve, redirectTransferTo } from "../../utils/utils";
import { transferService } from "@api";
import './retrieve.less';
const Retrieve = props => {
    const { match } = props;
    const isDisable = match.params.way === 'enable';
    const transferData = JSON.parse(sessionStorage['transferData'] || null);
    const emailLogicalName = transferData?.detail?.EmailOTP?.logicalName;
    const singpassLogicalName = transferData?.detail?.SingPass?.logicalName;
    const params = utils.geturlparam(window?.location.search);
    const { obj } = params;

    const handleSectionClick = (sectionType, from) => {
        if (sectionType === 'singpass' && from === 'retrieveSingPass') {
            transferToRetrieve(singpassLogicalName, from, obj?.proxyState);
        } else if (sectionType === 'singpass' && from === 'enable') {
            redirectTransferTo(singpassLogicalName, from);
        } else if (sectionType === 'emailOTP' && from === 'retrieveEmailOTP') {
            transferToRetrieve(emailLogicalName, from, obj?.proxyState);
        } else if (sectionType === 'emailOTP' && from === 'enable') {
            redirectTransferTo(emailLogicalName, from);
        }
    };

    const handleBackClick = (state) => {
        transferService.regetProxyState(state).then(() => {
            utils.redirectTo(routerPaths.home.compile({ active: "loginStudentID" }));
        });
    };

    return (
        <>
            <div className="retrieveForm">
                <div className='backTextIcon'>
                    <Icon className='fia-arrow-left' id="icon-back" onClick={() => handleBackClick(obj?.proxyState)}></Icon>
                    {isDisable ? <div className='text'>{i18n.get("CIS_Reenable_Title_Entry")}</div> : <div className='text'>{i18n.get("CIS_RetrieveStudentId_Title_Entry")}</div>}
                </div>
                {isDisable ? <div className="message">{i18n.get("CIS_Reenable_Description_Message")}</div> : <div className="message">{i18n.get('CIS_RetrieveStudentId_Message')}</div>}
                <div className="div-page-box">
                    <Container.Section className='container-retrieve retrieve-singpass' onClick={() => handleSectionClick('singpass', isDisable ? 'enable' : 'retrieveSingPass')}>
                        <a className="flex-column flex-align-center flex-justify-center">
                            <icon className="fia-singpass"></icon>
                            <div>{i18n.get('CIS_RetrieveStudentId_Singpass_Entry')}</div>
                            <span className="icon fia-arrow-right-subnav"></span>
                        </a>
                    </Container.Section>
                    <Container.Section className='container-retrieve retrieve-emailOTP' onClick={() => handleSectionClick('emailOTP', isDisable ? 'enable' : 'retrieveEmailOTP')}>
                        <a className="flex-column flex-align-center flex-justify-center">
                            <icon className="fia-email-envelope"></icon>
                            <div>{i18n.get('CIS_RetrieveStudentId_EmailOTP_Entry')}</div>
                            <span className="icon fia-arrow-right-subnav"></span>
                        </a>
                    </Container.Section>
                </div>
            </div>
        </>
    );
};

export default Retrieve;